import imageFallback from "@/assets/svg/image.svg";
import { Image } from "@/components/ui/image";
import { COLORS } from "@/constants/colors";
import { Template } from "@/types/template";

interface TemplateCardActiveProps {
  template: Template;
  onSelect: (template: Template) => void;
}

export function TemplateCardActive({
  template,
  onSelect
}: Readonly<TemplateCardActiveProps>) {
  const { title, short_description, thumbnail_icon, color } = template;

  return (
    <button
      type="button"
      className="group w-full h-full cursor-pointer rounded-xl border border-neutral-200 bg-white p-3 text-left transition-all hover:border-primary-500 hover:bg-[var(--template-hover-bg)]"
      style={
        {
          "--template-hover-bg": COLORS[color][50],
          "--template-hover-inner-bg": COLORS[color][700],
          "--template-hover-title-color": COLORS[color][500],
          "--template-inner-bg": COLORS[color][50]
        } as React.CSSProperties
      }
      onClick={() => onSelect(template)}
      aria-label={title}
    >
      <div className="flex flex-col gap-2 h-full">
        <div className="relative flex h-[120px] w-full items-center justify-center rounded-lg bg-[var(--template-inner-bg)] transition-colors group-hover:bg-[var(--template-hover-inner-bg)]">
          <div
            className="flex h-16 w-16 items-center justify-center rounded-full transition-colors"
            style={{ backgroundColor: COLORS[color][500] }}
          >
            <Image
              src={thumbnail_icon?.url}
              alt={title}
              fallbackSrc={imageFallback}
              className="h-10 w-10"
            />
          </div>
        </div>
        <div className="flex flex-col space-y-1">
          <p className="truncate text-sm font-semibold text-txtHeading group-hover:text-[var(--template-hover-title-color)]">
            {title}
          </p>
          <p className="line-clamp-3 text-xs text-dim-txt">
            {short_description}
          </p>
        </div>
      </div>
    </button>
  );
}
